import InnerComponent from '@Components/Settings/AccessControl';
import orgContainer from '@Components/AppContainer';

const AccessControl = () => ((orgContainer(InnerComponent)));
export default AccessControl;
